export default __webpack_public_path__ + "static/image-bootcamp-testimonials-3700e85d9787168e3fcd4ef96f9724fe.png";